import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '澳门彩资讯',
      links: [
        { label: '玩法规则', to: '/category/wanfa-guize' },
        { label: '开奖结果', to: '/category/kaijiang-jieguo' },
        { label: '开奖时间', to: '/category/kaijiang-shijian' },
      ],
    },
    {
      title: '购彩指南',
      links: [
        { label: '购买技巧', to: '/category/goumai-jiqiao' },
        { label: '中奖攻略', to: '/category/zhongjiang-gonglve' },
        { label: '号码分析', to: '/category/haoma-fenxi' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '联系我们', to: '/about#contact' },
        { label: '责任购彩', to: '/article/zeren-goucai-lixing-canyu' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-900 text-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-vip-crown-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                澳门彩官方指南
              </span>
            </Link>
            <p className="text-sm text-secondary-400 leading-relaxed">
              澳门彩官方指南致力于为彩民提供最全面、最权威的澳门彩资讯服务，涵盖玩法规则、开奖结果、购买技巧及中奖攻略等领域。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-400 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-500">
            &copy; {currentYear} 澳门彩官方指南 — 版权所有。本网站内容仅供资讯参考，不构成任何投注建议。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-secondary-500">理性购彩 量力而行</span>
          </div>
        </div>
      </div>
    </footer>
  );
}